import { render, staticRenderFns } from "./brandIntro.vue?vue&type=template&id=59078029&scoped=true&"
import script from "./brandIntro.vue?vue&type=script&lang=js&"
export * from "./brandIntro.vue?vue&type=script&lang=js&"
import style0 from "./brandIntro.vue?vue&type=style&index=0&id=59078029&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59078029",
  null
  
)

export default component.exports